'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var reactUtils = require('@chakra-ui/react-utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _excluded = ["isEditable", "defaultIsEditing", "isEditing", "isEmpty", "isDisabled", "onEdit", "onCancel", "onSubmit", "onChange", "translations", "id"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var _createContext = reactUtils.createContext({
    name: 'EditCardContext',
    errorMessage: 'useEditCardContext: `context` is undefined. Seems you forgot to wrap edit card components in `<EditCard />`.'
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  EditCardProvider = _createContext2[0],
  useEditCardContext = _createContext2[1];
function warnIfEditingAndNotEditable(props) {
  utils.warn({
    condition: (!!props.isEditing || !!props.defaultIsEditing) && !props.isEditable,
    message: 'Cannot edit a non editable edit card'
  });
}
/**
 * useEditCard
 *
 * React hook that provides the logic of an edit card.
 *
 * @TODO: Functionality is not yet implemented.
 */
function useEditCard(props) {
  var _props$isEditable = props.isEditable,
    isEditable = _props$isEditable === void 0 ? true : _props$isEditable,
    _props$defaultIsEditi = props.defaultIsEditing,
    defaultIsEditingProp = _props$defaultIsEditi === void 0 ? false : _props$defaultIsEditi,
    isEditingProp = props.isEditing,
    _props$isEmpty = props.isEmpty,
    isEmpty = _props$isEmpty === void 0 ? false : _props$isEmpty,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    onEditProp = props.onEdit,
    onCancelProp = props.onCancel,
    onSubmitProp = props.onSubmit,
    onChange = props.onChange,
    _props$translations = props.translations,
    translations = _props$translations === void 0 ? {
      cancel: 'Abbrechen',
      submit: 'Speichern',
      edit: 'Bearbeiten'
    } : _props$translations,
    id = props.id,
    htmlPropsSpread = _objectWithoutProperties__default["default"](props, _excluded);

  // @TODO: Will come from higher up (editable section/area) later. Functionality not yet implemented.
  var _useControllableState = react.useControllableState({
      defaultValue: defaultIsEditingProp,
      value: isEditingProp,
      onChange: onChange
    }),
    _useControllableState2 = _slicedToArray__default["default"](_useControllableState, 2),
    isEditing = _useControllableState2[0],
    setIsEditing = _useControllableState2[1];

  /**
   * Generate unique ids for all edit card components
   */
  var _useIds = react.useIds(id, "edit-card-button", "edit-card-submit", "edit-card-cancel", "edit-card"),
    _useIds2 = _slicedToArray__default["default"](_useIds, 4),
    buttonId = _useIds2[0],
    submitId = _useIds2[1],
    cancelButtonId = _useIds2[2],
    cardId = _useIds2[3];
  warnIfEditingAndNotEditable({
    isEditing: isEditing,
    defaultIsEditing: defaultIsEditingProp,
    isEditable: isEditable
  });
  var onEdit = React.useCallback(function () {
    setIsEditing(true);
  }, [isEditing, setIsEditing]);
  var onSubmit = React.useCallback(function () {
    setIsEditing(false);
  }, [setIsEditing]);
  var onCancel = React.useCallback(function () {
    setIsEditing(false);
  }, [setIsEditing]);
  var getEditButtonProps = React.useCallback(function () {
    var givenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, givenProps), {}, {
      ref: ref,
      type: 'button',
      id: buttonId,
      disabled: !!isDisabled || !isEditable || isEditing,
      'aria-expanded': !!isEditing,
      onClick: utils.callAllHandlers(givenProps.onClick, onEdit, onEditProp),
      children: translations.edit
    });
  }, [buttonId, isDisabled, isEditable, isEditing, onEdit, onEditProp, translations.edit]);
  var getSubmitButtonProps = React.useCallback(function () {
    var givenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, givenProps), {}, {
      ref: ref,
      id: submitId,
      disabled: !!isDisabled || !isEditing || isEmpty && !isEditing || !isEditable,
      // TODO: Functionality not yet implemented.
      onClick: utils.callAllHandlers(givenProps.onClick, onSubmit, onSubmitProp),
      children: translations.submit
    });
  }, [submitId, isDisabled, isEditing, isEmpty, isEditable, onSubmit, onSubmitProp, translations.submit]);
  var getCancelButtonProps = React.useCallback(function () {
    var givenProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, givenProps), {}, {
      ref: ref,
      id: cancelButtonId,
      disabled: !!isDisabled || !isEditing || isEmpty && !isEditing || !isEditable,
      // TODO: Functionality not yet implemented.
      onClick: utils.callAllHandlers(givenProps.onClick, onCancel, onCancelProp),
      children: translations.cancel
    });
  }, [cancelButtonId, isDisabled, isEditable, isEditing, isEmpty, onCancel, onCancelProp, translations.cancel]);
  var htmlProps = _objectSpread({
    role: 'region',
    id: cardId
  }, htmlPropsSpread);
  var onStartEdit = function onStartEdit() {
    setIsEditing(true);
  };
  var onStopEdit = function onStopEdit() {
    setIsEditing(false);
  };
  return {
    isEditable: isEditable,
    isEditing: isEditing,
    isEmpty: isEmpty,
    isDisabled: isDisabled,
    getEditButtonProps: getEditButtonProps,
    getSubmitButtonProps: getSubmitButtonProps,
    getCancelButtonProps: getCancelButtonProps,
    onStartEdit: onStartEdit,
    onStopEdit: onStopEdit,
    htmlProps: htmlProps,
    translations: translations
  };
}
exports.EditCardProvider = EditCardProvider;
exports.useEditCard = useEditCard;
exports.useEditCardContext = useEditCardContext;